import { sendEventDirectlyToHandler } from './api';
var log = function () { };
var kpiLogger;
var worker;
var workerLoadFromBlob;
var workerCreateDuration;
var workerInitStart;
var workerInstallationSucceeded;
var batchingIsEnabled;
var numEventsToTriggerUpload;
var stats = {
    processed: 0,
    eventsProcessingTime: 0,
    averageProcessingTimeCostPerEvent: 0,
    batches: 0,
    miscEvents: 0,
    workerInstallationSucceeded: false,
    workerFullInitDuration: 0
};
var workerInitialized = false;
var workerInitializationFailed = false;
var shutdownCalled = false;
var periodicUploaderTimerId = 0;
var limitTimerScheduled = false;
var queue = [];
export function startWorker(settings) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    try {
        if (!settings.workerUrl ||
            !settings.batchingSettings ||
            !settings.healthKpiMethods ||
            !((_b = (_a = settings.telemetryLoggerSettings) === null || _a === void 0 ? void 0 : _a.ulsLogger) === null || _b === void 0 ? void 0 : _b.sendTraceTag) ||
            workerInitialized ||
            workerInitializationFailed) {
            return false;
        }
        workerInitialized = true;
        workerLoadFromBlob = settings.loadFromBlob;
        batchingIsEnabled = settings.batchingSettings.enabled;
        numEventsToTriggerUpload = settings.batchingSettings.numEventsToTriggerUpload || 10;
        var timeToWaitBeforeAutoUploadingEvents = settings.batchingSettings.timeToWaitBeforeAutoUploadingEvents || 10 * 1000;
        periodicUploaderTimerId = self.setInterval(function () {
            flush();
        }, timeToWaitBeforeAutoUploadingEvents);
        log = (_d = (_c = settings.telemetryLoggerSettings) === null || _c === void 0 ? void 0 : _c.ulsLogger) === null || _d === void 0 ? void 0 : _d.sendTraceTag;
        log = log.bind((_e = settings.telemetryLoggerSettings) === null || _e === void 0 ? void 0 : _e.ulsLogger);
        kpiLogger = settings.healthKpiMethods;
        log(0x22052846 /* tag_8bs7g */, 383 /* msoulscat_Wac_Telemetry */, 50 /* Info */, 'Installing OTel worker');
        kpiLogger.recordKpiUsage();
        var createWorkerStart = (_f = performance === null || performance === void 0 ? void 0 : performance.now()) !== null && _f !== void 0 ? _f : 0;
        if (workerLoadFromBlob) {
            var workerBlob = new Blob([
                // Log installation failures as a warning under tag_8bs7h
                "try{importScripts('" + encodeURI(settings.workerUrl) + "');}catch(e){self.postMessage({tagId:570763335,level:15,message:'Failed to load worker script: '+e})}"
            ], {
                type: 'application/javascript'
            });
            worker = new Worker(URL.createObjectURL(workerBlob));
        }
        else {
            worker = new Worker(settings.workerUrl);
        }
        worker.onmessage = onWebWorkerMessage.bind(this);
        workerCreateDuration = ((_g = performance === null || performance === void 0 ? void 0 : performance.now()) !== null && _g !== void 0 ? _g : 0) - createWorkerStart;
        var workerInitStartTime = new Date().getTime();
        workerInitStart = (_h = performance === null || performance === void 0 ? void 0 : performance.now()) !== null && _h !== void 0 ? _h : 0;
        var settingsEvent = {
            kind: 'initialize',
            timestamp: workerInitStartTime,
            event: settings.telemetryLoggerSettings
        };
        sendToWorkerInternal([settingsEvent]);
        log(0x22052848 /* tag_8bs7i */, 383 /* msoulscat_Wac_Telemetry */, 50 /* Info */, "Created a Worker with url: " + settings.workerUrl);
    }
    catch (e) {
        log(0x22052849 /* tag_8bs7j */, 383 /* msoulscat_Wac_Telemetry */, 15 /* Warning */, "Failed to install the worker: " + e);
        kpiLogger.recordKpiFailure('UnexpectedException', undefined /* extendedProperties */);
        shutdown();
        workerInitializationFailed = true;
        workerInitialized = false;
    }
    return true;
}
function onWebWorkerMessage(event) {
    var _a;
    try {
        var ulsEvent = event.data;
        switch (ulsEvent.tagId) {
            case 0x2205284b /* tag_8bs7l */: {
                var workerInitDuration = ulsEvent.message;
                var fullInitWorkerDuration = ((_a = performance === null || performance === void 0 ? void 0 : performance.now()) !== null && _a !== void 0 ? _a : 0) - workerInitStart;
                var completeWorkerInitDuration = workerCreateDuration + fullInitWorkerDuration;
                // Fix up the uls message to be more user friendly
                ulsEvent.message = "Successfully installed the OTel worker: CompleteWorkerInitDuration=" + completeWorkerInitDuration + ", CreateWorkerDuration=" + workerCreateDuration + ", WorkerInitDuration=" + workerInitDuration + ", FullInitWorkerDuration=" + fullInitWorkerDuration;
                var prop = new Map();
                // Time it took to create a worker blob URL and call `new Worker(blobUrl)` in the main thread
                prop.set('CreateWorkerDuration', workerCreateDuration.toString());
                // How long it took for our 'init' message to go from the main thread -> worker
                prop.set('WorkerInitDuration', workerInitDuration.toString());
                // How long it took for our 'init' message to go from the main thread -> worker -> main thread
                prop.set('FullInitWorkerDuration', fullInitWorkerDuration.toString());
                // Time to create a worker plus the time tp send the 'init' message and have it go from thread -> worker -> main thread
                prop.set('CompleteWorkerInitDuration', completeWorkerInitDuration.toString());
                // Did we load the worker via a blob URL? Or via a script URL?
                prop.set('LoadFromBlob', workerLoadFromBlob.toString());
                kpiLogger.recordKpiSuccess(Math.round(fullInitWorkerDuration), prop);
                stats.workerInstallationSucceeded = true;
                stats.workerFullInitDuration = fullInitWorkerDuration;
                workerInstallationSucceeded = true;
                break;
            }
            case 0x22052847 /* tag_8bs7h */: {
                kpiLogger.recordKpiFailure('FailedToLoadScript', undefined /* extendedProperties */);
                break;
            }
            default: {
                break;
            }
        }
        log(ulsEvent.tagId, 383 /* msoulscat_Wac_Telemetry */, ulsEvent.level, "[Worker] " + ulsEvent.message);
    }
    catch (ex) {
        log(0x2205284c /* tag_8bs7m */, 383 /* msoulscat_Wac_Telemetry */, 15 /* Warning */, "Failed to process message from the worker: " + ex);
    }
}
// =======================================================================================================
export function sendToWorker(event) {
    if (!workerInitialized) {
        return;
    }
    if (batchingIsEnabled) {
        addEventToQueue(event);
    }
    else {
        sendToWorkerInternal([event]);
    }
    // If we encountered a shutdown event, flush all of the outstanding events to the webworker (including a shutdown one),
    // tear down the periodic timer and log session level telemetry.
    if (event.kind === 'shutdown') {
        shutdown();
    }
}
function addEventToQueue(event) {
    queue.push(event);
    if (queue.length < numEventsToTriggerUpload) {
        return;
    }
    if (!limitTimerScheduled) {
        self.setTimeout(function () { return flush(); }, 0);
        limitTimerScheduled = true;
    }
}
function flush() {
    limitTimerScheduled = false;
    if (queue.length <= 0) {
        return;
    }
    sendToWorkerInternal(queue);
    queue = [];
}
function sendToWorkerInternal(events) {
    var _a, _b;
    try {
        stats.processed += events.length;
        stats.batches += 1;
        for (var i = 0; i < events.length; i = i + 1) {
            if (events[i].kind === 'initialize' ||
                events[i].kind === 'addNamespaceMapping' ||
                events[i].kind === 'shutdown') {
                stats.miscEvents += 1;
            }
        }
        var start = (_a = performance === null || performance === void 0 ? void 0 : performance.now()) !== null && _a !== void 0 ? _a : 0;
        worker === null || worker === void 0 ? void 0 : worker.postMessage(events);
        stats.eventsProcessingTime += ((_b = performance === null || performance === void 0 ? void 0 : performance.now()) !== null && _b !== void 0 ? _b : 0) - start;
    }
    catch (ex) {
        log(0x2204b8ce /* tag_8bl9o */, 383 /* msoulscat_Wac_Telemetry */, 15 /* Warning */, "Failed to send message to the worker: " + ex);
    }
}
function shutdown() {
    var _a;
    if (!workerInitialized || shutdownCalled) {
        return;
    }
    shutdownCalled = true;
    try {
        flush();
        if (periodicUploaderTimerId) {
            self.clearInterval(periodicUploaderTimerId);
            periodicUploaderTimerId = 0;
        }
        if (!workerInstallationSucceeded) {
            var prop = new Map();
            var totalInitDelay = ((_a = performance === null || performance === void 0 ? void 0 : performance.now()) !== null && _a !== void 0 ? _a : 0) - workerInitStart;
            // Time it took to create a worker blob URL and call `new Worker(blobUrl)` in the main thread
            prop.set('CreateWorkerDuration', workerCreateDuration.toString());
            // Time passed since we used `worker.postMessage` to send an `init` event
            prop.set('FailedWorkerInitDuration', totalInitDelay.toString());
            prop.set('WasWorkerConstructorCalledSuccessfully', (!!worker).toString());
            kpiLogger.recordKpiFailure('ShutdownBeforeReady', prop);
            log(0x2205284d /* tag_8bs7n */, 383 /* msoulscat_Wac_Telemetry */, 15 /* Warning */, "Failed to install the worker. Waited for " + totalInitDelay + "ms");
        }
        logSessionLevelTelemetry();
    }
    catch (ex) {
        log(0x2205284f /* tag_8bs7p */, 383 /* msoulscat_Wac_Telemetry */, 15 /* Warning */, "Failed to shutdown otel worker: " + ex);
    }
}
function logSessionLevelTelemetry() {
    computeSessionAverages();
    logSessionLevelTelemetryViaUls();
    logSessionLevelTelemetryViaOTel();
}
function logSessionLevelTelemetryViaUls() {
    var msg = JSON.stringify(stats);
    // ASSERTTAG_IGNORE_START
    log(0x2205284e /* tag_8bs7o */, 383 /* msoulscat_Wac_Telemetry */, 50 /* Info */, msg);
    // ASSERTTAG_IGNORE_FINISH
}
function logSessionLevelTelemetryViaOTel() {
    var telemetryEvent = {
        name: 'Office.Online.Telemetry.OTelJS.WebWorker.Session.Stats',
        dataFields: [
            { name: 'Processed', double: stats.processed },
            { name: 'EventsProcessingTime', double: stats.eventsProcessingTime },
            { name: 'AverageProcessingTimeCostPerEvent', double: stats.averageProcessingTimeCostPerEvent },
            { name: 'Batches', double: stats.batches },
            { name: 'BatchingSettings', double: !batchingIsEnabled ? 0 : numEventsToTriggerUpload },
            { name: 'MiscEvents', double: stats.miscEvents },
            { name: 'WorkerInstallationSucceeded', bool: stats.workerInstallationSucceeded },
            { name: 'WorkerFullInitDuration', double: stats.workerFullInitDuration }
        ]
    };
    sendEventDirectlyToHandler({ kind: 'event', timestamp: new Date().getTime(), event: telemetryEvent });
}
function computeSessionAverages() {
    if (stats.processed > 0) {
        stats.averageProcessingTimeCostPerEvent = stats.eventsProcessingTime / stats.processed;
    }
}
//# sourceMappingURL=workerApi.js.map